import { useTranslation } from 'react-i18next';
import { siteInfo } from '@/mocks/site';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import AnimatedSection from '@/components/base/AnimatedSection';

const features = [
  { icon: 'ri-radar-line', title: 'aboutFeature1Title', desc: 'aboutFeature1Desc' },
  { icon: 'ri-fire-line', title: 'aboutFeature2Title', desc: 'aboutFeature2Desc' },
  { icon: 'ri-shield-check-line', title: 'aboutFeature3Title', desc: 'aboutFeature3Desc' },
];

const faqs = [
  {
    q: '黑料吃瓜是什么平台？',
    a: '黑料吃瓜是一个专注于娱乐爆料资讯的中文内容平台，为用户提供最新、最热的全网黑料吃瓜视频与每日大赛现场内容。我们致力于打造一个透明、公正的娱乐资讯聚合平台。',
  },
  {
    q: '平台上的爆料内容真实吗？',
    a: '我们对所有发布的内容进行严格的来源核实。独家首发栏目由专业调查团队经过深度追踪后发布，确保信息的真实性和可靠性。对于未经核实的传闻，我们会明确标注为"传闻"或"待核实"。',
  },
  {
    q: '如何参与每日大赛？',
    a: '每日大赛面向所有注册用户开放。您可以通过平台的投稿通道提交爆料内容，经过审核后即可参与评选。每周我们会根据内容质量、独家性和影响力评选出最佳爆料，并给予奖励。',
  },
  {
    q: '如何联系黑料吃瓜团队？',
    a: '您可以通过页面底部的联系邮箱、微信公众号或官方微博与我们取得联系。我们欢迎有价值的线索和合作提议，也接受合理的纠错与反馈。',
  },
];

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead
        title={`关于我们 - ${siteInfo.name}`}
        description="了解黑料吃瓜网的品牌使命、平台信誉与联系方式。我们致力于打造一个透明、公正的娱乐资讯平台。"
        keywords="黑料吃瓜,关于我们,平台介绍,联系方式,品牌使命"
        canonical="/about"
        schema={[
          {
            '@type': 'Organization',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            logo: { '@type': 'ImageObject', url: '/vite.svg' },
            contactPoint: {
              '@type': 'ContactPoint',
              email: siteInfo.email,
              contactType: '客服',
            },
          },
          {
            '@type': 'WebPage',
            name: `关于我们 - ${siteInfo.name}`,
            url: '/about',
            description: '了解黑料吃瓜网的品牌使命、平台信誉与联系方式。',
            inLanguage: 'zh-CN',
          },
          {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: '/about' },
            ],
          },
          {
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          },
        ]}
      />
      <Navbar />
      <main className="w-full pt-16 md:pt-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <Breadcrumbs items={[{ label: t('navAbout') }]} />
        </div>

        <AnimatedSection>
          <section className="w-full bg-background-50 py-12 md:py-20 px-4 md:px-8 lg:px-12">
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-sm text-primary-500 mb-4">{t('aboutMissionLabel')}</p>
              <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-8 leading-tight">
                {t('aboutMissionTitle')}
              </h1>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                {t('aboutMissionText')}
              </p>
            </div>
          </section>
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <section className="w-full bg-background-100 py-10 md:py-14 px-4 md:px-8 lg:px-12">
            <div className="mb-8 md:mb-10">
              <p className="text-sm text-foreground-600 mb-2">{t('aboutFeaturesLabel')}</p>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
                {t('aboutFeaturesTitle')}
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {features.map((f, idx) => (
                <div key={idx} className="bg-background-50 p-5 md:p-6 rounded-lg">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full border border-primary-500/30 text-primary-500 mb-4">
                    <i className={`${f.icon} text-lg md:text-xl`} />
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">{t(f.title)}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t(f.desc)}</p>
                </div>
              ))}
            </div>
          </section>
        </AnimatedSection>

        <AnimatedSection delay={200}>
          <section className="w-full bg-background-950 py-10 md:py-14 px-4 md:px-8 lg:px-12">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
              <div className="flex-1 lg:flex-[3]">
                <blockquote className="text-xl md:text-2xl lg:text-3xl font-serif text-foreground-50 leading-relaxed mb-6">
                  <span className="text-primary-500 text-3xl md:text-4xl">&ldquo;</span>
                  {t('aboutFounderQuote')}
                </blockquote>
                <div className="flex items-center gap-3">
                  <span className="text-sm font-semibold text-foreground-200">{t('aboutFounderName')}</span>
                  <span className="w-4 h-4 flex items-center justify-center rounded-full bg-green-500 text-white text-[10px]">
                    <i className="ri-check-line" />
                  </span>
                </div>
              </div>
              <div className="lg:flex-[2] w-full max-w-sm lg:max-w-none">
                <div className="relative w-full h-[400px] md:h-[500px] overflow-hidden rounded-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20of%20successful%20entrepreneur%20in%20modern%20minimal%20office%20setting%20with%20confident%20posture%20and%20natural%20window%20light%2C%20clean%20neutral%20background%20with%20warm%20tones%2C%20editorial%20corporate%20photography%20with%20sophisticated%20composition%20and%20professional%20atmosphere&width=600&height=800&seq=founder-portrait&orientation=portrait"
                    alt="创始人"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </section>
        </AnimatedSection>

        <AnimatedSection delay={300}>
          <section className="w-full bg-background-50 py-10 md:py-14 px-4 md:px-8 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              <div>
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-6">
                  {t('aboutContactTitle')}
                </h2>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                      <i className="ri-mail-line" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t('aboutContactEmail')}</p>
                      <p className="text-sm text-foreground-600">{siteInfo.email}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                      <i className="ri-wechat-line" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t('aboutContactWechat')}</p>
                      <p className="text-sm text-foreground-600">{siteInfo.wechat}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                      <i className="ri-weibo-line" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t('aboutContactWeibo')}</p>
                      <p className="text-sm text-foreground-600">{siteInfo.weibo}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-6">常见问题</h2>
                <div className="space-y-4">
                  {faqs.map((faq, idx) => (
                    <div key={idx} className="bg-background-100 rounded-lg p-4">
                      <h3 className="text-sm font-semibold text-foreground-950 mb-2">Q: {faq.q}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">A: {faq.a}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
}